import { useState } from 'react';
import { faqList } from '@/mocks/movies';
import SectionHeading from '@/pages/home/components/SectionHeading';

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="w-full bg-background-50 py-14 md:py-20">
      <div className="mx-auto w-full max-w-[1200px] px-4 md:px-8">
        <SectionHeading
          eyebrow="常见问题"
          title="关于这个页面，你可能想问"
          subtitle="从内容构成到筛选用法，先看这里，多数疑问都能找到答案。"
        />

        <div className="mt-10 flex flex-col divide-y divide-background-200 overflow-hidden rounded-lg border border-background-200 bg-background-100">
          {faqList.map((item, index) => {
            const isOpen = openIndex === index;
            return (
              <div key={item.q}>
                <h3>
                  <button
                    type="button"
                    onClick={() => setOpenIndex(isOpen ? null : index)}
                    aria-expanded={isOpen}
                    className="flex w-full items-center justify-between gap-4 px-4 py-4 text-left transition-colors duration-200 hover:bg-background-50 md:px-6 md:py-5"
                  >
                    <span className="font-heading text-sm font-bold text-foreground-950 md:text-base">{item.q}</span>
                    <span
                      className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full border transition-colors duration-200 ${
                        isOpen
                          ? 'border-primary-500 bg-primary-500 text-background-50'
                          : 'border-background-300 text-foreground-500'
                      }`}
                    >
                      <i className={isOpen ? 'ri-subtract-line' : 'ri-add-line'} aria-hidden="true" />
                    </span>
                  </button>
                </h3>
                {isOpen ? (
                  <div className="px-4 pb-5 md:px-6">
                    <p className="max-w-4xl text-sm leading-relaxed text-foreground-600">{item.a}</p>
                  </div>
                ) : null}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}